module.exports = __webpack_public_path__ + "media/Video 113b.0901731a.mp4";